import moment from "moment";
import { putMessageAsync } from "../../repository/ChatRepository";

export const buildAttachment = ({ remotePath, name, localPath, contentType }) => ({
  remotePath,
  name,
  localPath,
  contentType,
});

export const labelMap = {
  image: "Imagem 🖼️",
  application: "Arquivo 📃",
  video: "Video 📃",
  audio: "Audio 📃",
};

export const getMessageLabel = (type) => {
  for (const key in labelMap) {
    if (type.includes(key)) return labelMap[key];
  }
  return "Arquivo";
};

export const sendFirebaseMessage = async ({
  messageData,
  favorited,
  loggedUser,
  isAudioToSender = false,
}) => {
  const {
    id,
    content,
    user,
    userName,
    userEmail,
    idChat,
    attachment,
    date,
    serverDate,
  } = messageData;

  const sender = { name: userName, email: userEmail, id: user };
  const recipient = isAudioToSender ? sender : loggedUser;
  const chat = { id: idChat };
  const type = attachment?.contentType || "";

  const label = getMessageLabel(type);

  const builtAttachment = attachment ? buildAttachment(attachment) : null;

  console.log("FDF", loggedUser, favorited)

  return await putMessageAsync(
    chat,
    recipient,
    id,
    content || label,
    date,
    serverDate,
    builtAttachment,
    false,
    favorited
  );
};

export const buildFavoritedPayload = ({
  baseFavorited,
  status,
  loggedUser,
  projectId,
  eventSectorId,
}) => {
  const timestamp = moment.utc(Date.now()).format("YYYY-MM-DD");

  return {
    ...baseFavorited,
    projectId,
    byUser: loggedUser?.email,
    eventSectorId,
    addedAt: status === "added" ? timestamp : null,
    removedAt: status === "removed" ? timestamp : null,
    status,
  };
};
